export default {
      id: "countryFlag-Kyrgyzstan-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#countryFlag-Kyrgyzstan",
      toString: function () {
        return this.url;
      }
    }